import React from "react";
import { useStore } from "../store/store";
import { Html } from "@react-three/drei";

const LoadingBar: React.FC = () => {
  const artworkInFront = useStore((state) => state.artworkInFront);
  const isLoading = useStore((state) => state.isLoading);

  return (
    <Html
      className={`LoadingBar ${isLoading ? "" : "ended"} ${
        artworkInFront ? "blur" : ""
      }`}
    ></Html>
  );
};

export default LoadingBar;
